module.exports = __webpack_public_path__ + "static/media/tkn.a407b2c6.svg";